// @ts-nocheck
/**
 * Sistema Modular de Steps para Lens Configurator
 * Cada step es un módulo independiente que se puede añadir fácilmente
 */

// Clase base para todos los steps
class LensConfiguratorStep {
  constructor(configurator, options = {}) {
    this.configurator = configurator;
    this.options = options;
    this.stepKey = options.stepKey || 'unknown';
    this.title = options.title || 'Paso';
    this.description = options.description || '';
    this.isRequired = options.isRequired !== false;
    this.isVisible = options.isVisible !== false;
  }

  // Método que determina si este step debe mostrarse
  shouldShow() {
    return this.isVisible;
  }

  // Método que determina si este step debe saltarse
  shouldSkip() {
    return false;
  }

  // Renderizar el contenido del step
  render() {
    // Implementar en subclases
  }

  // Crear una tarjeta de opción estándar
  createOptionCard(key, option, type, isMultiple = false) {
    const card = document.createElement('div');
    card.className = 'option-card';
    card.dataset.key = key;
    card.dataset.type = type;
    card.dataset.multiple = isMultiple.toString();

    // Verificar si está seleccionado
    const isSelected = isMultiple
      ? Array.isArray(this.configurator.configuration[type]) && this.configurator.configuration[type].includes(key)
      : this.configurator.configuration[type] === key;

    if (isSelected) {
      card.classList.add('selected');
    }

    // Usar precio real del producto Shopify si está disponible
    let price = 0;
    if (option.basePrice !== undefined) {
      price = option.basePrice; // Precio desde Shopify API
    } else if (option.priceModifier !== undefined) {
      price = option.priceModifier; // Para materiales
    } else if (option.price !== undefined) {
      price = option.price; // Para tratamientos
    }

      // En el paso de prescripción no mostramos el texto 'Incluido' para precios a 0;
      // dejamos el campo vacío para evitar mostrar el 'budget' o indicador.
      let priceDisplay = price > 0 ? `+${this.configurator.formatPrice(price)}` : '';
      if (this.stepKey !== 'prescription') {
        priceDisplay = price > 0 ? priceDisplay : 'Incluido';
      }

      // No renderizamos el <span class="price"> si priceDisplay está vacío
      const priceSpan = priceDisplay ? `<span class="price">${priceDisplay}</span>` : '';

    // Usar nombre real del producto Shopify si está disponible
    const displayName = option.name || key;
    const displayDescription = option.description || '';

    // Indicador de disponibilidad
    let availabilityClass = '';
    let availabilityText = '';
    if (option.available === false) {
      availabilityClass = ' unavailable';
      availabilityText = '<span class="unavailable-text">No disponible</span>';
    }

    // Optional icon HTML (allow steps to pass an inline SVG in option.icon)
    const iconHtml = option.icon ? `<span class="option-icon">${option.icon}</span>` : '';

    // Optional images for product selection (option.images[] or option.image / option.imageSrc)
    let images = [];
    try {
      // Compatibilidad: soportar la clave nueva MOSTRAR_IMAGENES_PRODUCTO
      // manteniendo la antigua MOSTRAR_IMAGENES_PRODCUTO para proyectos existentes.
      const cfg = this.constructor && this.constructor.STEP_CONFIG ? this.constructor.STEP_CONFIG : {};
      const stepSupportsImages = cfg.MOSTRAR_IMAGENES_PRODUCTO === true || cfg.MOSTRAR_IMAGENES_PRODCUTO === true;
      if (stepSupportsImages) {
        if (Array.isArray(option.images) && option.images.length > 0) {
          images = option.images.map(img => (typeof img === 'string' ? img : (img && (img.src || img.src_url || img.url) ? (img.src || img.src_url || img.url) : null))).filter(Boolean);
        } else {
          const single = option.image || option.imageSrc || (option.image && option.image.src) || null;
          if (single) images = [single];
        }
      }
    } catch (e) { images = []; }

    let mediaHtml = '';
    if (images.length === 1) {
      mediaHtml = `<div class="option-media"><img src="${images[0]}" alt="${displayName}" loading="lazy"/></div>`;
    } else if (images.length > 1) {
      // Carousel markup (simple, no deps)
      const slides = images.map((src, i) => `<div class="carousel-slide" data-index="${i}"><img src="${src}" alt="${displayName} (${i + 1})" loading="lazy"/></div>`).join('');
      mediaHtml = `
        <div class="option-media carousel" data-current="0">
          <button type="button" class="carousel-prev header-nav-btn" aria-label="Anterior">‹</button>
          <div class="carousel-track">${slides}</div>
          <button type="button" class="carousel-next header-nav-btn" aria-label="Siguiente">›</button>
        </div>
      `;
    }

    card.innerHTML = `
      ${mediaHtml}
      <div class="option-header">
        ${iconHtml}
        <h3>${displayName}</h3>
        ${priceSpan}
      </div>
      ${displayDescription ? `<p class="option-description">${displayDescription}</p>` : ''}
      ${availabilityText ? `<div class="option-availability">${availabilityText}</div>` : ''}
    `;

    // Si encontramos un carousel, adjuntamos la lógica mínima de navegación
    if (images.length > 1) {
      try {
        // Nota: los estilos del carousel están centralizados en assets/lens-drawer.css

        const carouselEl = card.querySelector('.option-media.carousel');
        const track = carouselEl && carouselEl.querySelector('.carousel-track');
        const prev = carouselEl && carouselEl.querySelector('.carousel-prev');
        const next = carouselEl && carouselEl.querySelector('.carousel-next');
        if (carouselEl && track && prev && next) {
          let current = 0;
          const slidesCount = track.children.length;
          const update = (idx) => {
            current = idx < 0 ? slidesCount - 1 : (idx >= slidesCount ? 0 : idx);
            const offset = -current * 100;
            track.style.transform = `translateX(${offset}%)`;
            carouselEl.setAttribute('data-current', String(current));
          };
          prev.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current - 1); });
          next.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current + 1); });
          // Allow clicking the image to advance
          track.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current + 1); });
        }
      } catch (e) {
        // no-op
      }
    }

    // Aplicar clase de disponibilidad
    if (availabilityClass) {
      card.className += availabilityClass;
    }

    return card;
  }

  // Manejar selección de opción
  handleOptionSelect(card) {
    if (!card || !card.dataset) return;

    const key = card.dataset.key;
    const type = card.dataset.type;
    const isMultiple = card.dataset.multiple === 'true';

    if (isMultiple) {
      // Para tratamientos (múltiple selección)
      if (card.classList.contains('selected')) {
        if (Array.isArray(this.configurator.configuration[type])) {
          this.configurator.configuration[type] = this.configurator.configuration[type].filter(item => item !== key);
        }
      } else {
        if (!Array.isArray(this.configurator.configuration[type])) {
          this.configurator.configuration[type] = [];
        }
        if (!this.configurator.configuration[type].includes(key)) {
          this.configurator.configuration[type].push(key);
        }
      }
    } else {
      // Para tipo de cristal y material (selección única)
      // Quitar selección de otros
      const otherCards = document.querySelectorAll(`[data-type="${type}"]`);
      otherCards.forEach(otherCard => otherCard.classList.remove('selected'));

      this.configurator.configuration[type] = key;
    }

    // Si el tipo seleccionado es distinto de 'reading', limpiar magnification previa
    try {
      if (type === 'lensType' && key !== 'reading') {
        if (this.configurator && this.configurator.configuration) {
          delete this.configurator.configuration.magnification;
        }
        // Ocultar cualquier panel de graduación si existe en el DOM
        try {
          const wrapper = document.querySelector('.reading-graduation-wrapper');
          if (wrapper) wrapper.style.display = 'none';
          const readingCards = document.querySelectorAll('[data-type="lensType"][data-key="reading"], .ce-table-cell-reading');
          readingCards.forEach(rc => rc.classList.remove('selected'));
        } catch (e) {}
      }
    } catch (e) {}

    const preventAuto = card.dataset && card.dataset.preventAutoAdvance === 'true';

    // If preventAutoAdvance is set, do not toggle selection off automatically here;
    // let the step's own logic mark the card as completed when ready (e.g. after upload).
    if (preventAuto) {
      card.classList.add('selected');
      card.setAttribute('aria-selected', 'true');
    } else {
      card.classList.toggle('selected');
    }
    this.configurator.calculatePrice();
    this.configurator.updatePriceDisplay();
    this.configurator.updateDrawerFooter();

    // Auto-avanzar al siguiente paso después de seleccionar (excepto para tratamientos múltiples)
    if (!isMultiple && !preventAuto) {
      setTimeout(() => {
        this.configurator.nextStep();
      }, 100);
    }
  }

  // Obtener resumen de la selección actual para este step
  getSummary() {
    const config = this.configurator.configuration;
    const configData = this.configurator.config;
    const stepKey = typeof this.stepKey === 'string' ? this.stepKey : '';
    const summaryId = stepKey || (this.title ? this.title.toLowerCase().replace(/\s+/g, '-') : 'step');

    switch (stepKey) {
      case 'lensType':
      case 'lens-type':
        if (config.lensType && configData && configData.lensTypes && configData.lensTypes[config.lensType]) {
          const lensType = configData.lensTypes[config.lensType];
          return {
            id: summaryId,
            label: 'Tipo de Cristal',
            value: lensType.name,
            price: lensType.price || 0
          };
        }
        return { id: summaryId, label: 'Tipo de Cristal', value: 'No seleccionado', price: 0 };

      case 'material':
        if (config.material && configData && configData.materials && configData.materials[config.material]) {
          const material = configData.materials[config.material];
          return {
            id: summaryId,
            label: 'Material',
            value: material.name,
            price: material.price || 0
          };
        }
        return { id: summaryId, label: 'Material', value: 'No seleccionado', price: 0 };

      case 'treatments':
        if (Array.isArray(config.treatments) && config.treatments.length > 0 && configData && configData.treatments) {
          const treatmentNames = config.treatments
            .map(key => configData.treatments[key] ? configData.treatments[key].name : key)
            .filter(name => name);
          
          const totalPrice = config.treatments.reduce((sum, key) => {
            const treatment = configData.treatments[key];
            return sum + (treatment ? treatment.price || 0 : 0);
          }, 0);

          return {
            id: summaryId,
            label: 'Tratamientos',
            value: treatmentNames.join(', '),
            price: totalPrice
          };
        }
        return { id: summaryId, label: 'Tratamientos', value: 'Ninguno', price: 0 };

      case 'thickness':
        if (config.thickness && configData && configData.thickness && configData.thickness[config.thickness]) {
          const thickness = configData.thickness[config.thickness];
          return {
            id: summaryId,
            label: 'Grosor',
            value: thickness.name,
            price: thickness.price || 0
          };
        }
        return { id: summaryId, label: 'Grosor', value: 'No seleccionado', price: 0 };

      case 'progressiveType':
        if (config.progressiveType && configData && configData.progressiveTypes && configData.progressiveTypes[config.progressiveType]) {
          const progressiveType = configData.progressiveTypes[config.progressiveType];
          return {
            id: summaryId,
            label: 'Tipo Progresivo',
            value: progressiveType.name,
            price: progressiveType.price || 0
          };
        }
        return { id: summaryId, label: 'Tipo Progresivo', value: 'No seleccionado', price: 0 };

      default:
        return { id: summaryId, label: this.title, value: 'No configurado', price: 0 };
    }
  }

  /**
   * Determina si se puede avanzar desde este paso.
   * Cada step puede sobreescribir este método si requiere lógica específica.
   * Por defecto consultamos la configuración global y comprobamos valores comunes.
   * @returns {boolean}
   */
  canProceed() {
    try {
      if (!this.isRequired) return true;
      const cfg = this.configurator && this.configurator.configuration ? this.configurator.configuration : {};

      // Normalizar distintos nombres de stepKey (ej. 'lens-type' vs 'lensType')
      const key = String(this.stepKey || '').toLowerCase();

      if (key.includes('lens') && (key.includes('type') || key === 'lens-type' || key === 'lenstype' || key === 'lens')) {
        return !!cfg.lensType;
      }

      if (key.includes('material')) {
        return !!cfg.material;
      }

      if (key.includes('treatment') || key.includes('treatments')) {
        return Array.isArray(cfg.treatments) ? cfg.treatments.length > 0 : false;
      }

      if (key.includes('thickness') || key.includes('grosor')) {
        return !!cfg.thickness;
      }

      if (key.includes('progressive')) {
        // Si el tipo de lente actual no es progresivo, no exigimos selección
        if (cfg.lensType !== 'progressive') return true;
        return !!cfg.progressiveType;
      }

      if (key.includes('prescription') || key.includes('gradu')) {
        return Object.keys(cfg.prescription || {}).length > 0;
      }

      // Fallback: permitir avanzar por defecto (evita bloquear pasos desconocidos)
      return true;
    } catch (e) {
      return true;
    }
  }
}

// Hacer disponible globalmente
window.LensConfiguratorStep = LensConfiguratorStep;

// Nota: los estilos de las option-card deben gestionarse desde CSS del tema